/** @format */
'use strict';
jQuery(function($) {

    //
    // Add ID to main element, for skip to main content button
    const $mainElement = $('main')

    $mainElement.attr('id', 'js-main-element');

    //
    // SYOS seatmaps
    var syosContainer = document.querySelector(".tn-syos");

    if (syosContainer) {
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {

                // area map hotspots
                $('#m_smap23 area').click(function() {
                    const seatArea = $(this).attr('class');
                    $('body').removeClass('smap-23-screen-3 smap-23-screen-4 smap-23-screen-5');
                    $('body').addClass(seatArea);
                });

                // area buttons
                $( ".tn-syos-screen-button .tn-syos-screen-button__section-heading:contains('Upper')" ).click(function() {
                    $('body').removeClass('smap-23-screen-3 smap-23-screen-4 smap-23-screen-5');
                    $('body').addClass('smap-23-screen-5');
                });
                $( ".tn-syos-screen-button .tn-syos-screen-button__section-heading:contains('Lower')" ).click(function() {
                    $('body').removeClass('smap-23-screen-3 smap-23-screen-4 smap-23-screen-5');
                    $('body').addClass('smap-23-screen-3');
                });
                $( ".tn-syos-screen-button .tn-syos-screen-button__section-heading:contains('Pit')" ).click(function() {
                    $('body').removeClass('smap-23-screen-3 smap-23-screen-4 smap-23-screen-5');
                    $('body').addClass('smap-23-screen-4');
                });

                $('.tn-syos-btn-view-screens').click(function() {
                    $('body').removeClass('smap-23-screen-3 smap-23-screen-4 smap-23-screen-5');
                });

            });
        });
        observer.observe(syosContainer, {
            subtree: true,
            childList: true
        });
    }

    // change seat number to General Admission if a standing seat selected
    $(".tn-cart-item-detail__list-item--description:contains('Standing')").next().html('General Admission');

    // Move GiftAid below cart line items
    $('.tn-payment-page .tn-custom-giftaid').appendTo('.tn-payment-page .tn-cart__section--contributions');

    // Add body class dependent on venue
    if( $(".tn-event-detail__location:contains('Globe')").length > 0 ) {
        $('body').addClass('state--venue-globe');
    }
    if( $(".tn-event-detail__location:contains('Sam')").length > 0 ) {
        $('body').addClass('state--venue-swp');
    }

    function detectDomElements(element, callback, maxAttempts) {
        var attempts = 1;
        var timer = setInterval(function() {
            var items = document.querySelectorAll(element)

            if (attempts === maxAttempts) {
                clearInterval(timer);
            }

            if (items.length) {
                clearInterval(timer);
                if (typeof callback === "function") {
                    callback(items);
                }
            }

            attempts++
        }, 50);
    }


    // hide non full price zones on standing
    if (document.location.href.indexOf('z=99') > -1) {
        $('.tn-radio-button-list__list-item').hide();
        $('#tn-fieldset-seating-options').addClass('js-force-hide');
        if ($('.tn-ticket-selector__input-zone[data-zone-id="99"]').length) {
            $('.tn-ticket-selector__input-zone[data-zone-id="99"]').parent().parent().show();
            if ($(this).prop("checked", true)) {
                $('.tn-ticket-selector__pricetype-container[data-zone-id="99"]').show();
            }
        }
        if ($('.tn-ticket-selector__input-zone[data-zone-id="269"]').length) {
            $('.tn-ticket-selector__input-zone[data-zone-id="269"]').parent().parent().show();
            if ($(this).prop("checked", true)) {
                $('.tn-ticket-selector__pricetype-container[data-zone-id="269"]').show();
            }
        }
        if ($('.tn-ticket-selector__input-zone[data-zone-id="5546209"]').length) {
            $('.tn-ticket-selector__input-zone[data-zone-id="5546209"]').parent().parent().show();
            if ($(this).prop("checked", true)) {
                $('.tn-ticket-selector__pricetype-container[data-zone-id="5546209"]').show();
            }
        }
    }

    var syosContainer = document.querySelector(".tn-syos");

    // detect IE8 and above, and Edge and apply transforms to inline styles on mutation of the seat map svg
    if (document.documentMode || /Edge/.test(navigator.userAgent)) {
        // the code that needs executing when the .tn-syos-seat-container-viewport
        // is added and the svg within it exists
        var adjustSeatMap = function() {
            $(".tn-syos-seat-map__seat").each(function(){
                $(this).attr("transform", $(this).css("transform"));
            });
        }

        if (syosContainer) {
            var observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (document.querySelector(".tn-syos-seat-map__svg") && mutation.type === "childList") {
                        adjustSeatMap();
                    }
                });
            });
            observer.observe(syosContainer, {
                subtree: true,
                childList: true
            });
        }

    }

    // Check is the syos container
    if (syosContainer) {

        const $body = $('body')

        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                // Check for seat ID within each seatmap layout
                if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"126353\"]") && mutation.type === "childList") {
                    // If so then add body class, and remove other body classes
                    $body.addClass('seatmap--lower-gallery');
                    $body.removeClass('seatmap--middle-gallery seatmap--upper-gallery');
                } else if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"121385\"]") && mutation.type === "childList") {
                    $body.addClass('seatmap--middle-gallery');
                    $body.removeClass('seatmap--lower-gallery seatmap--upper-gallery');
                } else if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"117136\"]") && mutation.type === "childList") {
                    $body.addClass('seatmap--upper-gallery');
                    $body.removeClass('seatmap--middle-gallery seatmap--lower-gallery');
                }
            });
        });
        observer.observe(syosContainer, {
            subtree: true,
            childList: true
        });
    }

    // A price type placeholder box with white space characters
    // Hide it when there's no actual text inside
    let pricetypePlaceholder = document.querySelector("#instructions-choose-zone");
    if(pricetypePlaceholder && !pricetypePlaceholder.innerText.length) {
        pricetypePlaceholder.style.display = "none";
    }
});


// mutationobserver-shim v0.3.2 (github.com/megawac/MutationObserver.js)
// Authors: Graeme Yeates (github.com/megawac)
window.MutationObserver=window.MutationObserver||function(w){function v(a){this.i=[];this.m=a}function I(a){(function c(){var d=a.takeRecords();d.length&&a.m(d,a);a.h=setTimeout(c,v._period)})()}function p(a){var b={type:null,target:null,addedNodes:[],removedNodes:[],previousSibling:null,nextSibling:null,attributeName:null,attributeNamespace:null,oldValue:null},c;for(c in a)b[c]!==w&&a[c]!==w&&(b[c]=a[c]);return b}function J(a,b){var c=C(a,b);return function(d){var f=d.length,n;b.a&&3===a.nodeType&&
a.nodeValue!==c.a&&d.push(new p({type:"characterData",target:a,oldValue:c.a}));b.b&&c.b&&A(d,a,c.b,b.f);if(b.c||b.g)n=K(d,a,c,b);if(n||d.length!==f)c=C(a,b)}}function L(a,b){return b.value}function M(a,b){return"style"!==b.name?b.value:a.style.cssText}function A(a,b,c,d){for(var f={},n=b.attributes,k,g,x=n.length;x--;)k=n[x],g=k.name,d&&d[g]===w||(D(b,k)!==c[g]&&a.push(p({type:"attributes",target:b,attributeName:g,oldValue:c[g],attributeNamespace:k.namespaceURI})),f[g]=!0);for(g in c)f[g]||a.push(p({target:b,
type:"attributes",attributeName:g,oldValue:c[g]}))}function K(a,b,c,d){function f(b,c,f,k,y){var g=b.length-1;y=-~((g-y)/2);for(var h,l,e;e=b.pop();)h=f[e.j],l=k[e.l],d.c&&y&&Math.abs(e.j-e.l)>=g&&(a.push(p({type:"childList",target:c,addedNodes:[h],removedNodes:[h],nextSibling:h.nextSibling,previousSibling:h.previousSibling})),y--),d.b&&l.b&&A(a,h,l.b,d.f),d.a&&3===h.nodeType&&h.nodeValue!==l.a&&a.push(p({type:"characterData",target:h,oldValue:l.a})),d.g&&n(h,l)}function n(b,c){for(var g=b.childNodes,
q=c.c,x=g.length,v=q?q.length:0,h,l,e,m,t,z=0,u=0,r=0;u<x||r<v;)m=g[u],t=(e=q[r])&&e.node,m===t?(d.b&&e.b&&A(a,m,e.b,d.f),d.a&&e.a!==w&&m.nodeValue!==e.a&&a.push(p({type:"characterData",target:m,oldValue:e.a})),l&&f(l,b,g,q,z),d.g&&(m.childNodes.length||e.c&&e.c.length)&&n(m,e),u++,r++):(k=!0,h||(h={},l=[]),m&&(h[e=E(m)]||(h[e]=!0,-1===(e=F(q,m,r,"node"))?d.c&&(a.push(p({type:"childList",target:b,addedNodes:[m],nextSibling:m.nextSibling,previousSibling:m.previousSibling})),z++):l.push({j:u,l:e})),
u++),t&&t!==g[u]&&(h[e=E(t)]||(h[e]=!0,-1===(e=F(g,t,u))?d.c&&(a.push(p({type:"childList",target:c.node,removedNodes:[t],nextSibling:q[r+1],previousSibling:q[r-1]})),z--):l.push({j:e,l:r})),r++));l&&f(l,b,g,q,z)}var k;n(b,c);return k}function C(a,b){var c=!0;return function f(a){var k={node:a};!b.a||3!==a.nodeType&&8!==a.nodeType?(b.b&&c&&1===a.nodeType&&(k.b=G(a.attributes,function(c,f){if(!b.f||b.f[f.name])c[f.name]=D(a,f);return c})),c&&(b.c||b.a||b.b&&b.g)&&(k.c=N(a.childNodes,f)),c=b.g):k.a=
a.nodeValue;return k}(a)}function E(a){try{return a.id||(a.mo_id=a.mo_id||H++)}catch(b){try{return a.nodeValue}catch(c){return H++}}}function N(a,b){for(var c=[],d=0;d<a.length;d++)c[d]=b(a[d],d,a);return c}function G(a,b){for(var c={},d=0;d<a.length;d++)c=b(c,a[d],d,a);return c}function F(a,b,c,d){for(;c<a.length;c++)if((d?a[c][d]:a[c])===b)return c;return-1}v._period=30;v.prototype={observe:function(a,b){for(var c={b:!!(b.attributes||b.attributeFilter||b.attributeOldValue),c:!!b.childList,g:!!b.subtree,
a:!(!b.characterData&&!b.characterDataOldValue)},d=this.i,f=0;f<d.length;f++)d[f].s===a&&d.splice(f,1);b.attributeFilter&&(c.f=G(b.attributeFilter,function(a,b){a[b]=!0;return a}));d.push({s:a,o:J(a,c)});this.h||I(this)},takeRecords:function(){for(var a=[],b=this.i,c=0;c<b.length;c++)b[c].o(a);return a},disconnect:function(){this.i=[];clearTimeout(this.h);this.h=null}};var B=document.createElement("i");B.style.top=0;var D=(B="null"!=B.attributes.style.value)?L:M,H=1;return v}(void 0);
//# sourceMappingURL=mutationobserver.map


(function () {
    var lng = "en";

    var translate = function translate(string, to) {
        var translations, translation;
        // true: Translations were found for the current item's HTML
        if (translations = stringTranslations[string]) {
            // true: A translation for the requested language was found
            // false: The text for the current item remains unchanged
            if (translation = translations[to]) {
                return translation;
            }
        }

        return string;
    };

    var stringTranslations = {
        "Donate and support": {
            en: "Projects at the Globe you can support with a donation"
        },
        "Email Donate": {
            en: "By email"
        },
        "Phone Donate": {
            en: "By phone"
        },
        "Post Donate": {
            en: "By post"
        },
        "SMS Donate": {
            en: "By SMS"
        },
        "Events, news, membership": {
            en: "Events, news and memberships from Shakespeare’s Globe"
        },
        "Email Events": {
            en: "By email"
        },
        "Phone Events": {
            en: "By phone"
        },
        "Post Events": {
            en: "By post"
        },
        "SMS Events": {
            en: "By SMS"
        },
        "Your interests": {
            en: "<h2>Your interests</h2><span>In addition to receiving occasional news from the Globe, you can choose to hear more about the following:</span>"
        }
    };

    // Loop through all the selectors
    [".control-label", ".checkbox label"].forEach(function (selector) {
        // Loop through all the results for the current selector
        document.querySelectorAll(selector).forEach(function (item) {
            var html = item.innerHTML.trim();
            item.innerHTML = translate(html, lng);
        });
    });

    var regexTranslations = {
        ".checkbox label": [{
            pattern: /([\w&\s?]+)/gi,
            callback: function callback(match, a) {
                return translate(a.trim(), lng);
            }
        }]
    };

    var _loop = function _loop(selector) {
        var translations = regexTranslations[selector];

        document.querySelectorAll(selector).forEach(function (item) {
            translations.forEach(function (translation) {
                item.innerHTML = item.innerHTML.replace(translation.pattern, translation.callback);
            });
        });
    };

    for (var selector in regexTranslations) {
        _loop(selector);
    }
})();
